import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@soundxyz/font-awesome/pro-light-svg-icons/index.mjs';
import type { CSS } from '@components-shared/src/stitches';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { webappUriPath } from '@utils/url';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const EditShelfMenuItem = ({
  label,
  shelfWebappUri,
  css,
}: {
  label: string;
  shelfWebappUri: string;
  css?: CSS;
}) => {
  return (
    <AccessibleLink
      pathnameUri={webappUriPath(shelfWebappUri, {
        subpath: '/edit',
      })}
    >
      <DropdownMenuItem>
        <FontAwesomeIcon icon={faPencil} size="lg" />
        <MenuItemLabel css={css}>{label}</MenuItemLabel>
      </DropdownMenuItem>
    </AccessibleLink>
  );
};
